import { TableState } from '@tanstack/react-table';
import { useMemo } from 'react';
import { ConnectedFacility } from '../../../api';
import { SortDataPayload } from '../../models/sort';
import { ConnectionRequestFilterState } from '../ConnectionRequestsFilters';
import { ListFooter } from '../ListFooter';
import { Table } from '../Table';
import { useColumns } from './useColumns';
// import { ConnectionStatusCategoryEnum } from './ConnectionStatusCategoryEnum';

interface ConnectionRequestsTableProps {
  isLoading: boolean;
  list?: ConnectedFacility[];
  // statusCategoryFilter: ConnectionStatusCategoryEnum[];
  totalCount: number;
  pageSize: number;
  currentPage: number;
  isProvider: boolean;
  filters: ConnectionRequestFilterState;
  handleChangePage: (page: number) => void;
  onRowClick: (row: ConnectedFacility) => void;
  onReject: (row: ConnectedFacility) => void;
  onAccept: (row: ConnectedFacility) => void;
  onEntityCancel: (row: ConnectedFacility) => void;
  onUpdateSort: (data: SortDataPayload) => void;
}

export const ConnectionRequestsTable = ({
  isLoading,
  list,
  // statusCategoryFilter,
  totalCount,
  pageSize,
  currentPage,
  handleChangePage,
  onRowClick,
  isProvider,
  onReject,
  onAccept,
  onEntityCancel,
  filters,
  onUpdateSort,
}: ConnectionRequestsTableProps) => {
  const columns = useColumns({
    onAccept,
    onReject,
    onEntityCancel,
    filters,
    onSetSort: onUpdateSort,
    isProvider,
    onRowClick,
  });

  const state: Partial<TableState> = useMemo(
    () => ({
      columnPinning: {
        // left: ['facility', 'provider'],
        // left: ['provider_action'],
        // right: ['provider_action', 'entity_action'],
      },
      columnVisibility: {
        provider: !isProvider,
        entity_name: isProvider,
        // specialty: !isProvider,
        sender: !isProvider,
        // clearance_status:
        //   statusFilter.includes(ConnectionRequestStatus.ACCEPTED) ||
        //   isEqual(statusFilter.sort(), Object.values(ConnectionRequestStatus).sort()),
        entity_action: false,
        //   // TODO: This is a temporary solution to hide the cancel button for the provider
        //   !isProvider &&
        //   !statusFilter.includes(ConnectionRequestStatus.ACCEPTED) &&
        //   !statusFilter.includes(ConnectionRequestStatus.REJECTED),
        // provider_action:
        //   isProvider &&
        //   ((!statusFilter.includes(ConnectionRequestStatus.ACCEPTED) &&
        //     !statusFilter.includes(ConnectionRequestStatus.REJECTED)) ||
        //     isEqual(statusFilter.sort(), Object.values(ConnectionRequestStatus).sort())),
        // connection_status: isEqual(
        //   statusCategoryFilter.sort(),
        //   Object.values(ConnectionRequestStatus).sort()
        // ),
      },
    }),
    [isProvider]
  );

  return (
    <div className="card border w-100 rounded bg-white shadow mb-6">
      <Table
        isLoading={isLoading}
        columns={columns}
        state={state}
        data={list as []}
        size={pageSize}
        onRowClick={onRowClick}
        tableClassName="fs-14 global_table-action-row table-requests"
      />

      <ListFooter
        title="Connection"
        totalCount={totalCount}
        pageSize={pageSize}
        currentPage={currentPage}
        onChangePage={handleChangePage}
        containerClassName="py-3 px-2 text-muted"
      />
    </div>
  );
};
